import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MenuItemPath, MenuItem } from '@enums/menu-item.enum';
import { AuthGuard } from 'app/core/guards/auth.guard';
import { CustomerComponent } from './pages/customer/customer.component';

const routes: Routes = [
    {
      path: MenuItemPath.get(MenuItem.customer),
      component: CustomerComponent,
      canActivate: [AuthGuard]
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
})

export class CustomerRoutingModule { }
